import ProductMediaType from "./product-media-type";

export default ProductMediaType;